import * as yup from 'yup';

export const description = yup.string().required('Este campo es obligatorio');
